import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import cartReducer from "./CartReducer";
import authUserReducer from "./AuthUserReducer";
import RequestReducer from "./RequestReducer";
import ServiceListReducer from "./ServiceListReducer";
import ProcedureReducer from "./ProcedureReducer";
import CompanyReducer from "./CompanyReducer";
import SubscriptionReducer from "./SubscriptionReducer";
import TicketReducer from "./TicketReducer";
import userReducer from "./userReducer";
import serviceReducer from "./serviceReducer";
import transactionReducer from "./TransactionReducer";
import paymentReducer from "./paymentReducer";

import { REMOVE_AUTHED_USER } from "../actions/AuthUserActions";
import formalityReducer from "./FormalityReducer";
import followUpReducer from "./FollowUpReducer";

const appReducer = combineReducers({
  cart: cartReducer,
  authUser: authUserReducer,
  request: RequestReducer,
  serviceList: ServiceListReducer,
  procedures: ProcedureReducer,
  companies: CompanyReducer,
  subscriptions: SubscriptionReducer,
  tickets: TicketReducer,
  users: userReducer,
  services: serviceReducer,
  transactions: transactionReducer,
  payments: paymentReducer,
  formalityRequest: formalityReducer,
  followUps: followUpReducer,
});

// Gestion de la réinitialisation du store
const rootReducer = (state, action) => {
  if (action.type === REMOVE_AUTHED_USER) {
    storage.removeItem("persist:root");
    state = undefined;
  }
  return appReducer(state, action);
};

const rootPersistConfig = {
  key: "root",
  storage,
  blacklist: [],
};

export default persistReducer(rootPersistConfig, rootReducer);
